import { Badge, Box, Button, Container, Grid, MenuItem, Select } from "@mui/material";
import { Link } from "react-router-dom";
import { calculateCartItems, calculateCartPrice } from "../utils/cart";
import { useContext } from "react";
import globalContext from '../context/context'
import { useTranslation } from "react-i18next";

const menuStyle = {
    color: '#656565',
    textTransform: 'none',
    fontWeight: '400',
    px: 2,
    "&:hover": {
        color: '#d93e45',
        bgcolor: 'tranparent'
    }
}

const secondMenuStyle = {
    color: '#656565',
    textTransform: 'none',
    fontWeight: '600',
    textDecoraton: 'none',
    "&:hover": {
        color: '#d93e45',
        bgcolor: 'tranparent'
    }
}

function Header() {

    const { contextData: { cart, currency }, isLoggedIn, logout, setLanguage } = useContext(globalContext);
    const { t, i18n } = useTranslation();
    return (
        <>
            <Box sx={{ py: 1, bgcolor: '#fff', borderBottom: '1px solid #d93e45', boxShadow: '0px 5px 40px 0px rgba(217,62,69,0.35)' }}>
                <Container>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Grid item>
                            <Link to="/">
                                <img src="/images/myplusair-logo-fekvo.png" alt="myxpery-logo" width="220px" />
                            </Link>
                        </Grid>
                        <Grid sx={{ color: '#292929' }} item>
                            <Button variant="text" sx={{ ...menuStyle, display: { xs: 'none', md: 'initial' } }} component={Link} to="/">
                                {t("header.home")}
                            </Button>
                            <Badge color="error" badgeContent={calculateCartItems(cart)}>
                                <Button variant="text" sx={{ ...menuStyle }} component={Link} to="/cart">
                                    {t("header.cart")}
                                    <Box sx={{ fontSize: '9px', display: 'inline-block', paddingLeft: '3px' }}>({calculateCartPrice(cart)} {currency})</Box>
                                </Button>
                            </Badge>
                            {isLoggedIn() ?
                                <>
                                    <Button variant="text" sx={{ ...menuStyle, display: { xs: 'none', md: 'initial' } }} component={Link} to="/my-booking">
                                        {t("header.myBooking")}
                                    </Button>
                                    <Button variant="text" onClick={() => logout()} sx={{ ...menuStyle, display: { xs: 'none', md: 'initial' } }} >
                                        {t("header.logout")}
                                    </Button>
                                </>
                                : <Button variant="text" component={Link} to="/login" sx={{ ...menuStyle, display: { xs: 'none', md: 'initial' } }} >
                                    {t("header.login")}
                                </Button>}
                            <Button variant="text" sx={{ ...menuStyle, display: { xs: 'none', md: 'initial' } }} component={Link} to="/contact">
                                {t("header.contactUs")}
                            </Button>

                            <Button sx={menuStyle} onClick={() => {
                                // setLanguage(i18n.language.includes('hu') ? 'en' : 'hu')
                                return null;
                            }} >
                                {i18n.language.includes('hu') ? 'ENG' : 'ENG'}
                            </Button>

                        </Grid>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >

                        {[{
                            title: t("header.transfer"),
                            link: "transfer"
                        },
                        {
                            title: t("header.parking"),
                            link: "parking"
                        },
                        {
                            title: t("header.lounge"),
                            link: "lounge"
                        },
                        {
                            title: "Fast track",
                            link: "fast-track"
                        }].map((m, mKey) => (
                            <Grid key={mKey} sx={{ pt: 3, opacity: m.link ? 1 : 0.4 }} item>
                                <Link style={{ textDecoration: 'none', textAlign: 'center', display: 'block' }} to={m.link ?? null}>
                                    <img src="/images/myxpery-menu.png" style={{ verticalAlign: 'middle' }} alt="myxpery-menu" width="25px" />
                                    <Button variant="text" sx={{ ...secondMenuStyle, display: { xs: 'block', md: 'initial' }, fontSize: { xs: '10px', md: 'initial'} }} >
                                        {m.title}
                                    </Button>
                                </Link>
                            </Grid>))}


                    </Grid>
                </Container>
            </Box>
        </>
    );
}

export default Header;
